import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';

const ThemeToggle = ({ mode, theme, onToggle }) => (
  <Tooltip title={mode === 'dark' ? 'מצב בהיר' : 'מצב כהה'}>
    <IconButton
      onClick={onToggle}
      aria-label="החלפת ערכת צבעים"
      sx={{
        color: theme.accent,
        border: `1px solid ${theme.borderSoft}`,
        width: 44,
        height: 44,
        '&:hover': { bgcolor: theme.surfaceHover, borderColor: theme.border },
      }}
    >
      {mode === 'dark' ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
    </IconButton>
  </Tooltip>
);

export default ThemeToggle;
